import { jwtDecode } from "jwt-decode";
import isAccess from "./checkAccess";
import {
  setToastMessage,
  setToastOpen,
  CustomerSearchAction,
    CustomerManagementData,

} from "../Actions/CustomerManagementAction";

/* ----------------------------------
 * Common helpers
 * ---------------------------------- */

export const fallback = (value) => value || "N/A";

const SORT_FIELD_MAP = {
  customerName: "firstName",
  customerId: "id",
};
/* ----------------------------------
 * Access control
 * ---------------------------------- */

export const getCustomerAccess = (token) => {
  const decodedToken = jwtDecode(token);
  return isAccess(decodedToken.userRole, "Customer Management");
};

/* ----------------------------------
 * Fetch customers
 * Supports:
 *  - without filters (initial load)
 *  - with filters
 * ---------------------------------- */

export const fetchCustomers = (dispatch, page, filters = {}) => {
  const hasSearch =
    typeof filters.searchTerm === "string" &&
    filters.searchTerm.trim().length > 0;

  const hasSort = filters.sortBy && filters.sortBy !== "createdAt";
  const hasFilters =
    Array.isArray(filters.statuses) && filters.statuses.length > 0;

  const useSearchAPI = hasSearch || hasSort || hasFilters;

  const apiSortBy =
    SORT_FIELD_MAP[filters.sortBy] || filters.sortBy || "createdAt";

  if (useSearchAPI) {
    dispatch(
      CustomerSearchAction({
        page: page - 1,
        size: 5,
        sortBy: apiSortBy,
        sortDirection: filters.sortDirection,
        searchTerm: filters.searchTerm?.trim() || "",
        statuses: filters.statuses || [],
      })
    );
  } 
  else {
    dispatch( CustomerSearchAction({
        page: page - 1,
        size: 5,
        sortBy: apiSortBy,
        sortDirection: filters.sortDirection,
        searchTerm: filters.searchTerm?.trim() || "",
        statuses: filters.statuses || [],
      }));
  }
};


/* ----------------------------------
 * Process table rows
 * ---------------------------------- */

export const processCustomerRows = (dashboardData) => {
  if (!dashboardData) return [];
  
  const rows = Array.isArray(dashboardData)
    ? dashboardData
    : dashboardData.content || [];

  return rows.map((row) => ({
    id: row.id || row.customerId,
    customerName: [row.firstName, row.lastName].filter(Boolean).join(" ") || "N/A",
    customerId: row.id || fallback(row.customerId),
    emailaddress: fallback(row.email),
    phoneNumber: fallback(row.phoneNumber),
    alternateNumber: fallback(row.alternateNumber),
    billingAddress: fallback(row.address),
  }));
};



/* ----------------------------------
 * Toast helper
 * ---------------------------------- */

export const triggerToast = (dispatch, message, open = true) => {
  dispatch(setToastMessage(message));
  dispatch(setToastOpen(open));
};

/* ----------------------------------
 * DataGrid column configuration
 * ---------------------------------- */

export const getCustomerColumns = (
  edit,
  canDelete,
  handleEdit,
  setOpenDeleteModal,
  setDeviceIdToDelete,
  EditIcon,
  DeleteIcon,
  AccessibleTooltip,
) => [
 {
    field: "customerName",
    headerName: "Customer Name",
    flex: 2,
    sortable: true,
  },
  {
    field: "customerId",
    headerName: "Customer ID",
    flex: 1,
    sortable: true,
  },
  {
    field: "emailaddress",
    headerName: "Email Address",
    flex: 2,
    sortable: false,
  },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
    sortable: false,
  },
  {
    field: "alternateNumber",
    headerName: "Alternate Phone Number",
    flex: 1,
    sortable: false,
  },
  {
    field: "billingAddress",
    headerName: "Billing Address",
    flex: 1,
    sortable: false,
  },
  ...(edit || canDelete
    ? [
        {
          field: "Actions",
          headerName: "Actions",
          flex: 1,
          align: "right",
          headerAlign: "right",
          sortable: false,
          disableColumnMenu: true,
          renderCell: (row) => (
            <div style={{ display: "flex", gap: "10px" }} role="list">
              {edit && (
                <div role="listitem">
                  <AccessibleTooltip title="Edit">
                    <button
                      id={`edit-${row.row.id}`}
                      onClick={() =>
                        handleEdit(row, `edit-${row.row.id}`)
                      }
                      className="icon-btn edit-icon-btn"
                      aria-label="Edit"
                    >
                      <img
                        src={EditIcon}
                        alt=""
                        aria-hidden="true"
                        className="editIcon"
                      />
                    </button>
                  </AccessibleTooltip>
                </div>
              )}

              {canDelete && (
                <div role="listitem">
                  <AccessibleTooltip title="Delete">
                    <button
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setDeviceIdToDelete(row.row.id);
                      }}
                      
                      className="icon-btn delete-icon-btn"
                      aria-label="Delete"
                    >
                      <img
                        src={DeleteIcon}
                        alt=""
                        aria-hidden="true"
                        className="deleteIcon"
                      />
                    </button>
                  </AccessibleTooltip>
                </div>
              )}
            </div>
          ),
        },
      ]
    : []),
];
